import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export abstract class TabVerifier {

  constructor(protected readonly url: URL) {}

  abstract isProduct(): boolean;

}
